import React from "react";
import {render} from "react-dom";
import {Provider} from "react-redux";
import {createStore, applyMiddleware, compose} from "redux";
import {reducers} from "./reducers";
import thunkMiddleware from "redux-thunk";
import {fieldChanged} from "./actions";
import {ButtonCustom, ButtonBergen} from "./containers/Button";

// Lazy load dialogs - they're only needed when opened
const loadCustomCourseDialog = () => import(/* webpackChunkName: "custom-course-dialog" */ './containers/Dialog').then(module => module.CustomCourseDialog);
const loadBergenCourseDialog = () => import(/* webpackChunkName: "bergen-course-dialog" */ './containers/Dialog').then(module => module.BergenCourseDialog);

let store = createStore(reducers, compose(
    applyMiddleware(thunkMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
));

render(
    <Provider store={store}>
        <div>
            <ButtonCustom/>
        </div>
    </Provider>,
    document.getElementById('customCourse')
);

// Lazy load dialog when container exists
const customCourseDialogEl = document.getElementById('customCourseDialog');
if (customCourseDialogEl) {
    loadCustomCourseDialog().then(CustomCourseDialog => {
        render(
            <Provider store={store}>
                <div>
                    <CustomCourseDialog/>
                </div>
            </Provider>,
            customCourseDialogEl
        );
    });
}

const bergenButton = document.getElementById('bergenCourse');
const bergenDialog = document.getElementById('bergenCourseDialog');

if (bergenButton) {
    render(
        <Provider store={store}>
            <div>
                <ButtonBergen/>
            </div>
        </Provider>,
        bergenButton
    );
}

if (bergenDialog) {
    loadBergenCourseDialog().then(BergenCourseDialog => {
        render(
            <Provider store={store}>
                <div>
                    <BergenCourseDialog/>
                </div>
            </Provider>,
            bergenDialog
        );
    });
}


store.dispatch(fieldChanged('name', userName, 'custom'));
store.dispatch(fieldChanged('email', userEmail, 'custom'));
store.dispatch(fieldChanged('phone', userPhone, 'custom'));
store.dispatch(fieldChanged('language', languageName, 'custom'));

store.dispatch(fieldChanged('name', userName, 'bergen'));
store.dispatch(fieldChanged('email', userEmail, 'bergen'));
store.dispatch(fieldChanged('phone', userPhone, 'bergen'));


// WEBPACK FOOTER //
// ./src/custom_course/app.js